var TableOptions = new Class({
	initialize: function(){
		document.getElements('.ava_apts, .disp_blds').each(function(_el){
			this.process_table(_el);
		}.bind(this));
	},

	process_table: function(_table){
		var _tbody = _table.getElement('.tbody');

		var url_signin = G? _tbody.getAttribute('data-rpc-signin') : null;

		// compile the save button so the saveToProfile widget will work
		_table.getElements('.cr-save-to-profile').each(function(_el){
			setTimeout(function () {
				// note: isCompiled is being set on crSaveToProfile widget
				if(!_el.isCompiled) {
					Core.compile_html(_el);
				}
			}, 100);
		});

		_tbody.getElements('.w_blimp.floorplan_link, .w_blimp.gallery_link').each(function(_el){
			new BlimpExtPhotogallery(_el, {
				draggable: true,
				show_veil: true,
				add_change_mode_options: true
			});
		});

		_tbody.getElements('.map_view').each(function(_el){
			// do not include the map view link if it's in the popup
			if(_el.getParent('div.w_popup')) return;

			if(_el.getParent('.ava_apts')){
				new BlimpExtListingUtilities(_el, {
					draggable: true
				});
			}
			else{
				new BlimpExtMap(_el, {
					draggable: true
				});
			}
		});

		_tbody.getElements('.contact_us a').each(function(_el){
			new Blimp.Form(_el, {draggable: true});
		});
	}
});
